/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { isError } from "@epic-mw/error-types";

import { getApiPath } from "../utils";

export interface AuthAccount {
	isLoggedIn: boolean;
	country?: string;
	displayName?: string;
	email?: string;
	id?: string;
	preferredLanguage?: string;
	cabinedMode?: boolean;
}

export interface AuthRes {
	bearerTokenValid: boolean;
	clearedOffline: boolean;
	accountId: string;
	upgradedBearerToken: boolean;
	/**
	 * The account as the server sees it after any repair. Present so the client
	 * does not need a second call to `/account`, and so it never disagrees with
	 * the session this same request just validated.
	 */
	account?: AuthAccount;
	/** True when this request found a dead session and cleared it. */
	repairedSession?: boolean;
}

export const auth = async (serverUrl?: string): Promise<AuthRes> => {
	try {
		console.log("auth", { serverUrl: `${getApiPath(serverUrl)}/auth` });
		const response = await fetch(`${getApiPath(serverUrl)}/auth`);
		const json: AuthRes = await response.json();
		return json;
	} catch (err) {
		console.error("auth() failed to load", isError(err) && err.message);
		throw err;
	}
};
